import processOrderRequest, {DOC_ACTION_PREPARE} from "../requests/processOrderRequest";

const prepareOrderAction = async (get, session, afterPrepare) => {
    const resp = await processOrderRequest(session, get().orderID, DOC_ACTION_PREPARE);
    if(!resp.ok)
        throw resp.value;


    if(afterPrepare)
        await afterPrepare();
}

export default prepareOrderAction;